import React, { useState, useEffect } from "react";
import DynamicIcon from './DynamicIcon';



const TextSlideshow = ({apiUrl, windowWidth}) => {
  const itemsPerPage = Number(`${windowWidth > 900 ? 3 : windowWidth > 500 ? 2 : 1}`)
const itemsPerRow = Number(`${windowWidth > 900 ? 3 : windowWidth > 500 ? 2 : 1}`)
  const [currentPage, setCurrentPage] = useState(1);
  const [slides, setSlides] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    fetch(apiUrl) 
    .then((response) => response.json()) 
        .then(data => {
          setSlides(data);
        setIsLoading(false);
      })
      .catch(err => {
        setError(err);
        setIsLoading(false);
      });
  }, [apiUrl]);
// }, []);


  function findFirstImageUrl(text) {
    const fallbackUrl = 'https://example.com/default-image.jpg'
    const regex = /<img\s+[^>]*?src=(['"])(.*?)\1/i; // Define a regular expression to match the image tag and capture just the URL
    // const regex = /<img\s+[^>]*?src=(['"])(.*?)\1[^>]*?>/i; // Define a regular expression to match the image tag and capture the entire element

    const match = text.match(regex);
  
    if (match) {
      return match[2]; // Return the second element in the match array, which should be the captured URL
      // return match[0]; // Return the entire matched string, which should be the captured image element

    } else {
      return fallbackUrl;
    }
  }

slides.forEach((slide) => {
const text = slide.content.rendered
const firstImageUrl = findFirstImageUrl(text);
slide.imageUrl = firstImageUrl
// slide.title.rendered = slide.title.rendered.replace('&#8211;', "-").slice(0, 100)+'...\nweiter lesen'
slide.title.rendered = slide.title.rendered.replace('&#8211;', "-").replace('&#038;', '&')

})

// console.log('Slides:', slides)


  const totalPages = Math.ceil(slides.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleItems = slides.slice(startIndex, endIndex);

  const handlePrevious = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNext = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const renderRows = () => {
    const rows = [];

    for (let i = 0; i < visibleItems.length; i += itemsPerRow) {
      const rowItems = visibleItems.slice(i, i + itemsPerRow);
      rows.push(
        <div className="textRow" key={i}>
          {rowItems.map((item) => (
            <div className="text-wrapper" key={item.id}>
            <a href={item.link}>
            <div 
            className="item"
            style={{backgroundImage: `linear-gradient(to bottom, transparent 80%, rgba(0,0,0,0.5)), url(${item.imageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center'}} 
            key={item.id}
            >
              {/* <img src={item.imageUrl} alt={item.title.rendered} /> */}
              <span>{item.title.rendered}</span>
            </div>
            </a>
            </div>
          ))}
        </div>
      );
    }

    return rows;
  };

  return (
    <div className="carousel">
    {error && <div>{error}</div>}
    {isLoading && <div>Loading...</div>}
      {renderRows()}
      <div className="controls">
        <button aria-label="previous" disabled={currentPage === 1} onClick={handlePrevious}>
          {/* Prev */}
          <DynamicIcon icon={"arrowCircleLeft"} id="icon"/>
        </button>
        <button aria-label="next" disabled={currentPage === totalPages} onClick={handleNext}>
          {/* Next */}
          <DynamicIcon icon={"arrowCircleRight"} id="icon"/>
        </button>
      </div>
    </div>
  );
};

export default TextSlideshow;